import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcadmin.widget.user.add');
import { OnInit, OnDestroy, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-gsdcadmin-widget-user-add',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcadmin.widget.user.add/view.scss */
/* src/app/portal.gsdcadmin.widget.user.add/view.scss: no such file or directory */`],
})
export class PortalGsdcadminWidgetUserAddComponent implements OnInit, OnDestroy {
    @Input() view: any;
    @Output() close = new EventEmitter<boolean>();
    @ViewChild('dialog') dialog: ElementRef<HTMLElement>;
    public communities: any[] = [];
    public communitiesLoading = false;
    public communitiesFailed = false;
    public errorMessages: any = {};
    public accountNameValid = '';
    public accountNameChecking = false;
    public pending = false;
    public submissionError = '';
    private checkedAccountName = '';
    private destroyed = false;
    private returnFocus = document.activeElement as HTMLElement;
    public user: any = {
        account_name: '', first_name: '', last_name: '', email: '',
        institution: '', department: '', community_id: '', role: 'user'
    };

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('admin', '/landing');
        if (this.destroyed) return;
        await this.service.render();
        this.dialog?.nativeElement.focus();
        await this.loadCommunities();
    }

    public ngOnDestroy() {
        this.destroyed = true;
        if (this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
    }

    public async loadCommunities() {
        if (this.communitiesLoading) return;
        this.communitiesLoading = true; this.communitiesFailed = false;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('get_communities');
            if (code !== 200 || !Array.isArray(data)) throw new Error('communities');
            this.communities = data.sort((a, b) => a.name.localeCompare(b.name));
        } catch {
            this.communities = []; this.communitiesFailed = true;
        } finally {
            this.communitiesLoading = false;
            if (!this.destroyed) await this.service.render();
        }
    }

    private profile() {
        const { account_name, first_name, last_name, email, community_id, role } = this.user;
        return { account_name, first_name: first_name.trim(), last_name: last_name.trim(), email: email.trim(), community_id, role };
    }

    public async checkAccountName() {
        if (this.accountNameChecking || this.pending) return;
        this.resetAccountNameCheck();
        this.errorMessages.account_name = '';
        const accountName = this.user.account_name;
        const profile = JSON.stringify(this.profile());
        if (!/^[a-z_][a-z0-9_.-]{0,63}$/.test(accountName)) {
            this.errorMessages.account_name = '아이디는 영문 소문자 또는 밑줄로 시작하는 1~64자의 소문자·숫자·밑줄·점·하이픈이어야 합니다.';
            await this.service.render();
            return;
        }
        this.accountNameChecking = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('check_account_name', {
                account_name: accountName, profile
            }, { timeout: 135000 });
            if (this.destroyed || profile !== JSON.stringify(this.profile())) return;
            if (code === 200) {
                this.accountNameValid = data?.retry ? '이전 생성 작업을 같은 정보로 다시 진행할 수 있습니다.' : '사용 가능한 아이디입니다.';
                this.checkedAccountName = accountName;
            } else {
                this.errorMessages.account_name = typeof data === 'string' ? data : '아이디 중복 여부를 확인하지 못했습니다. 잠시 후 다시 확인해주세요.';
            }
        } catch {
            if (profile === JSON.stringify(this.profile()))
                this.errorMessages.account_name = '아이디 중복 여부를 확인하지 못했습니다. 잠시 후 다시 확인해주세요.';
        } finally {
            this.accountNameChecking = false;
            if (!this.destroyed) await this.service.render();
        }
    }

    public resetAccountNameCheck() {
        this.checkedAccountName = ''; this.accountNameValid = ''; this.errorMessages.account_name = '';
        this.service.render();
    }

    public validateInputs(): boolean {
        this.errorMessages = {};
        if (!/^[a-z_][a-z0-9_.-]{0,63}$/.test(this.user.account_name))
            this.errorMessages.account_name = '아이디는 영문 소문자 또는 밑줄로 시작하는 1~64자의 소문자·숫자·밑줄·점·하이픈이어야 합니다.';
        else if (this.checkedAccountName !== this.user.account_name)
            this.errorMessages.account_name = '아이디 중복 확인을 해주세요.';
        if (!this.user.first_name.trim()) this.errorMessages.first_name = '이름을 입력해주세요.';
        if (!this.user.last_name.trim()) this.errorMessages.last_name = '성을 입력해주세요.';
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.user.email.trim()))
            this.errorMessages.email = '유효한 이메일을 입력해주세요.';
        if (!this.communities.some(community => community.id === this.user.community_id))
            this.errorMessages.community_id = '커뮤니티를 선택해주세요.';
        if (!['user', 'manager'].includes(this.user.role))
            this.errorMessages.role = '계정 유형을 확인해주세요.';
        return Object.keys(this.errorMessages).length === 0;
    }

    public async createUser() {
        if (this.pending || this.accountNameChecking || this.communitiesLoading || this.communitiesFailed) return;
        this.submissionError = '';
        if (!this.validateInputs()) {
            await this.service.render();
            this.dialog.nativeElement.querySelector<HTMLElement>('[aria-invalid="true"]')?.focus();
            return;
        }
        this.pending = true;
        await this.service.render();
        try {
            const payload = {
                ...this.profile(), institution: this.user.institution.trim(), department: this.user.department.trim(),
                password: this.service.auth.hash(this.user.account_name + '5678')
            };
            const { code, data } = await wiz.call('create_user', payload, { timeout: 135000 });
            if (code === 200) {
                this.pending = false;
                this.closeModal();
                this.service.alert.success(this.user.role === 'manager'
                    ? '계정이 생성되었습니다. 커뮤니티 정보에서 서비스 담당자로 지정해주세요.'
                    : '사용자가 성공적으로 생성되었습니다.');
            } else {
                this.submissionError = typeof data === 'string' ? data : '사용자 생성에 실패했습니다.';
            }
        } catch {
            this.submissionError = '사용자 생성에 실패했습니다.';
        } finally {
            this.pending = false;
            if (!this.destroyed) await this.service.render();
        }
    }

    public onDialogKey(event: KeyboardEvent) {
        if (this.service.alert?.isshow) return;
        if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); this.closeModal(); }
        if (event.key !== 'Tab') return;
        const items = Array.from(this.dialog.nativeElement.querySelectorAll<HTMLElement>('button:not(:disabled), input:not(:disabled), select:not(:disabled)'))
            .filter(item => !item.matches(':disabled') && item.getClientRects().length > 0);
        const first = items[0], last = items[items.length - 1];
        if (!first) { event.preventDefault(); this.dialog.nativeElement.focus(); return; }
        if (event.shiftKey && (document.activeElement === first || document.activeElement === this.dialog.nativeElement)) {
            event.preventDefault(); last.focus();
        } else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }

    public closeModal() {
        if (!this.pending) this.close.emit(false);
    }
}

export default PortalGsdcadminWidgetUserAddComponent;